import { connect } from 'react-redux';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { EditorState } from '@ublend-npm/aula-editor';
import { editSpacePost } from '@core/actions/space/posts';
import editComment from '@core/actions/comment/update';
import { isInstructor } from '@core/selectors/classroom';
import { currentUserId as getCurrentUserId } from '@core/selectors/user';
import { isAntivirusFileScanEnabled } from '@core/constants/launchDarklyFeatureFlags';
import { AulaState } from '@core/types/state';
import AulaEditorWithAnalytics from '@app/components/presentational/common/AulaEditor/AulaEditorWithAnalytics';
import AulaEditorWithAnalyticsWithoutPlugins from '@app/components/presentational/common/AulaEditor/AulaEditorWithAnalyticsWithoutPlugins';
import generateEditorConfig from '../../../generateEditorConfig';
import PostModal from './PostModal';

const mapStateToProps = (state: AulaState, ownProps: any) => {
  const isEducator = isInstructor(state, getCurrentUserId(state));

  return {
    isSavingPost: false,
    editorConfig: generateEditorConfig({
      state,
      itemId: ownProps?.itemId,
      itemType: ownProps?.itemType,
      enableAntivirusFileScan: isAntivirusFileScanEnabled(ownProps?.flags),
    }),
    EditorComponent: isEducator
      ? AulaEditorWithAnalytics
      : AulaEditorWithAnalyticsWithoutPlugins,
  };
};

const mapDispatchToProps = (dispatch: any, ownProps: any) => ({
  onSubmit: (content: EditorState) => {
    let result;
    if (ownProps.itemClass === 'UBClassRoomPost') {
      result = dispatch(
        editSpacePost({
          postId: ownProps?.itemId,
          content: JSON.stringify(content),
          scheduledFor: undefined,
        })
      );
    } else if (ownProps.itemClass === 'UBComment') {
      result = dispatch(editComment(JSON.stringify(content), ownProps?.itemId));
    }

    if (!result) {
      return Promise.reject(new Error('Failed to update content'));
    }

    return result;
  },
});

const EditPostModalContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PostModal as any);

export default withLDConsumer()(EditPostModalContainer);
